// Dictionnaire français (langue par défaut) — textes repris à l'identique du site actuel.
export const fr = {
  meta: {
    htmlLang: "fr",
    ogLocale: "fr_FR",
    ogLocaleAlternate: "en_US",
    dateLocale: "fr-FR",
  },
  zones: "Nice · Sophia Antipolis · Cannes · Antibes · Monaco · Alpes-Maritimes · France et international (remote)",
  role: "Consultante marketing stratégique",
  logoAlt: "Logo Bouge Ton Marketing — consultante en stratégie de marque et marketing PME",
  nav: {
    mainAria: "Navigation principale",
    mobileAria: "Navigation mobile",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    homeAria: "Magali Clouzet — Accueil",
    tagline: "Marketing stratégique",
    bookCall: "Prendre rendez-vous",
    links: [
      { label: "Accueil", path: "/" },
      { label: "Qui suis-je ?", path: "/qui-suis-je" },
      { label: "Mes services", path: "/services" },
      { label: "Blog", path: "/blog" },
      { label: "FAQ", path: "/faq" },
      { label: "Contact", path: "/contact" },
    ],
  },
  common: {
    home: "Accueil",
    skipLink: "Aller au contenu principal",
    breadcrumbAria: "Fil d'Ariane",
    offerBadge: "Offre",
    discoverOffer: "Découvrir cette offre",
    requestQuote: "Demander un devis",
    bookCall: "Prendre rendez-vous",
    readSuffix: "de lecture",
    cta: {
      title: "Échangeons sur votre projet",
      text: "Un premier échange de 30 minutes, gratuit et sans engagement. Nous parlons de vos enjeux, et vous repartez avec une vision claire des prochaines étapes.",
      ctaLabel: "Prendre rendez-vous",
    },
  },
  footer: {
    tagline: "Bouge ton marketing",
    description:
      "Consultante marketing stratégique pour PME, start-ups et TPE. Basée sur la Côte d'Azur, j'interviens à Nice, Sophia Antipolis, Cannes, Antibes, Monaco, dans les Alpes-Maritimes, en France et à l'international (remote).",
    navTitle: "Navigation",
    navAria: "Navigation de pied de page",
    servicesTitle: "Mes services",
    servicesAria: "Services",
    linkedinAria: "Profil LinkedIn de Magali Clouzet",
    copyright: "Magali Clouzet — Consultante marketing stratégique. Tous droits réservés.",
    legal: "Mentions légales",
    privacy: "Politique de confidentialité",
  },
  home: {
    seo: {
      title: "Conseil Stratégie Marketing & CMO Côte d'Azur | Magali Clouzet",
      description:
        "Boostez la croissance de votre PME ou start-up sur la Côte d'Azur. Conseil en stratégie marketing et direction externalisée à temps partagé sur-mesure.",
    },
    hero: {
      badge: "Consultante en stratégie marketing — PME · Start-ups · TPE",
      h1: { l1: "Transformez votre", l2: "marketing en vrai", l3a: "levier", l3b: "de croissance" },
      subtitle:
        "J'aide les dirigeants à bâtir leur stratégie de marque, sécuriser leurs lancements de produits et piloter leur marketing — de la vision stratégique à l'exécution opérationnelle.",
      ctaPrimary: "Prendre rendez-vous",
      ctaSecondary: "Découvrir mes offres",
      note: "12 ans d'expérience marketing au sein de groupes internationaux",
      scroll: "Faites défiler",
      imageAlt:
        "Consultante en stratégie marketing PME à Nice et Sophia Antipolis — feuille de route, audit de marque et analyse concurrentielle",
      badges: [
        "Direction Marketing Externalisée",
        "Stratégie de Marque & Positionnement",
        "Plans de Lancement (Go-to-Market)",
      ],
    },
    marquee: ["Stratégie de Marque", "Positionnement", "Plans de Lancement", "Marketing Stratégique", "Formation", "Fractional CMO", "Audit Marketing"],
    positioning: {
      tag: "Mon positionnement",
      h2: "Transformer votre marketing en moteur de croissance",
      bold: "Je ne vends pas simplement du conseil marketing.",
      promise:
        "Ma promesse : structurer le marketing de votre entreprise pour en faire un vrai levier de croissance — piloté, mesurable, actionnable.",
      cta: "Réserver un échange (30 min)",
      pillars: [
        { title: "Un diagnostic rigoureux", text: "Analyse de votre situation, de vos enjeux et ressources pour définir une stratégie adaptée à votre entreprise." },
        { title: "Une méthode pragmatique", text: "Une démarche structurée, adaptée à vos ressources et à votre réalité opérationnelle." },
        { title: "Des priorités clairement établies", text: "Les leviers clés hiérarchisés pour concentrer vos efforts là où ils ont le plus d'impact." },
        { title: "Une feuille de route à 90 jours", text: "Un plan d'action concret avec des responsabilités et des échéances claires." },
        { title: "Des résultats mesurables", text: "Des tableaux de bord et de KPI clairs pour suivre le progrès, ajuster les actions et mesurer leur impact." },
      ],
    },
    painPoints: {
      tag: "Vos problématiques",
      h2: "Vous vous reconnaissez dans une de ces situations ?",
      situations: [
        { bold: "Vous préparez le lancement d'un nouveau produit ou service…", rest: "mais vous ne savez pas par où commencer ni quelles actions prioriser pour maximiser vos chances de succès." },
        { bold: "Vous avez développé une excellente offre…", rest: "mais vous avez du mal à toucher les bons clients ou à expliquer clairement ce qui vous différencie." },
        { bold: "Votre entreprise grandit…", rest: "mais votre marketing manque de structure et vous avez le sentiment de multiplier les actions sans réelle stratégie." },
        { bold: "Votre équipe marketing est débordée…", rest: "et vous manquez de temps pour prendre du recul, définir les priorités ou piloter efficacement les projets." },
        { bold: "Vous auriez besoin d'un directeur marketing…", rest: "mais recruter à temps plein n'est pas la bonne solution aujourd'hui." },
      ],
      bannerA: "Si vous vous êtes reconnu dans une ou plusieurs de ces situations, je peux vous aider à structurer votre stratégie et à transformer vos ambitions en un",
      bannerStrong: "plan d'action concret",
      bannerCta: "Réservez un diagnostic gratuit (30 min)",
    },
    offers: {
      tag: "Mes Offres - Conseil & Direction Marketing",
      h2: "Trois formats, un objectif : votre croissance.",
      seeAll: "Voir le détail des services",
      customA: "Besoin d'un accompagnement spécifique ? Toutes mes prestations sont adaptables. J'interviens également sur des missions ponctuelles sur mesure — un atelier stratégique, une prise de parole, un audit ciblé.",
      customLink: "Contactez-moi",
      customB: "pour discuter de votre projet.",
    },
    whyMe: {
      tag: "Mes engagements",
      h2: "Pourquoi travailler avec moi",
      subtitle: "4 engagements pour votre croissance",
      chapters: [
        { title: "Vos enjeux d'abord, ma méthode ensuite", text: "Une approche sur-mesure, centrée sur vos objectifs et votre réalité. Chaque recommandation part de votre contexte : vos clients, vos ressources et vos contraintes. Si une action ne sert pas directement votre croissance, elle n'a pas sa place dans la feuille de route." },
        { title: "De la stratégie à l'exécution : une interlocutrice", text: "De l'audit initial au pilotage opérationnel, vous avez une interlocutrice unique à chaque étape. J'interviens sur la stratégie, les ateliers, la coordination des prestataires et les arbitrages, jusqu'à la mise en œuvre et l'obtention de résultats concrets." },
        { title: "Zéro « bullshit » marketing", text: "Pas de promesses miracles, pas d'effets d'annonce. Je privilégie des choix stratégiques assumés, expliqués simplement, et une transparence totale sur ce qui fonctionne comme sur ce qui doit être ajusté." },
        { title: "Des résultats mesurés, un marketing piloté par la performance", text: "Chaque mission débute avec des indicateurs clés (KPI) définis ensemble. Vous disposez d'une visibilité continue sur l'avancement des actions. L'objectif : transformer votre marketing en un investissement piloté, mesurable et rentable." },
      ],
    },
    method: {
      tag: "Construire votre stratégie marketing : ma méthode",
      h2: "Six étapes, une trajectoire claire.",
      subtitle:
        "Une démarche éprouvée auprès des PME, start-ups et entreprises en croissance — du diagnostic stratégique aux résultats mesurés.",
      steps: [
        { title: "Comprendre vos enjeux", text: "Analyse approfondie de votre marché, de vos cibles et de votre modèle économique. Tout commence par l'écoute." },
        { title: "Diagnostiquer l'existant", text: "Un état des lieux objectif : forces, leviers sous-exploités, angles morts et leviers d'acquisition prioritaires." },
        { title: "Structurer la stratégie", text: "Positionnement, proposition de valeur, canaux de diffusion et moyens nécessaires pour l'exécuter." },
        { title: "Prioriser la feuille de route", text: "Un plan d'action clair, pour concentrer vos ressources là où l'impact est le plus fort." },
        { title: "Déployer & Exécuter", text: "Mise en œuvre opérationnelle en lien direct avec vos équipes et prestataires." },
        { title: "Mesurer & Optimiser le ROI", text: "Suivi régulier des indicateurs de performance clés (KPI) pour effectuer les arbitrages nécessaires et garantir une amélioration continue." },
      ],
    },
    ai: {
      tag: "Marketing & Intelligence Artificielle",
      h2: "L'IA, quand elle fait vraiment bouger le marketing.",
      subtitle:
        "Ni gadget ni promesse miracle : j'intègre l'intelligence artificielle de façon pragmatique, au service de votre stratégie. Un accélérateur — jamais un substitut.",
      uses: [
        { title: "Contenus", text: "Produire plus. Pas penser moins. L'IA accélère la production, l'expertise humaine garde le cap." },
        { title: "Analyse", text: "Vos données et retours clients enfin exploités, pas seulement stockés." },
        { title: "Veille", text: "Détecter plus vite les mouvements du marché, des concurrents et des clients." },
        { title: "Automatisations", text: "Moins de tâches répétitives. Plus de temps pour la stratégie et les décisions." },
      ],
    },
    testimonials: {
      tag: "Témoignages",
      h2: "Ils m'ont fait confiance.",
      placeholder: "Témoignage client à venir",
    },
    articles: {
      tag: "Le blog",
      h2: "Derniers articles",
      seeAll: "Tous les articles",
    },
    faq: {
      tag: "Questions fréquentes",
      h2: "Ce que vous vous demandez avant de me contacter.",
      seeAll: "Voir toutes les questions",
    },
  },
  about: {
    seo: {
      title: "Magali Clouzet | Consultante Marketing Senior Côte d'Azur",
      description:
        "Découvrez mon parcours et ma vision du marketing : une approche pragmatique, humaine et moderne pour faire décoller votre PME sur Nice, Cannes & Antibes.",
    },
    breadcrumb: "Qui suis-je ?",
    tag: "Qui suis-je ?",
    h1: "Magali Clouzet, consultante en stratégie marketing et de marque sur la Côte d'Azur",
    p1: "J'accompagne les dirigeants de PME, fondateurs de start-ups et TPE en croissance à Nice, Antibes, Cannes, Sophia Antipolis et Monaco — ainsi qu'à distance en France et à l'international.",
    p2strong: "Mon expertise : transformer votre offre en un véritable levier de croissance, grâce à une stratégie de marque et marketing claire.",
    p2rest: "J'interviens sur le positionnement, le lancement de produits et services (Go-to-Market), l'élaboration de campagnes et le pilotage marketing — de la réflexion stratégique à la mise en œuvre opérationnelle.",
    p3a: "Après 12 ans à piloter des lancements et des stratégies de marque au sein de groupes internationaux, j'apporte à votre entreprise une",
    p3strong: "expertise senior",
    p3b: "directement opérationnelle — sans la structure ni le coût d'une équipe interne. Lancement de produit, repositionnement, structuration d'un marketing en croissance : je m'adapte à votre enjeu, pas l'inverse.",
    photoAlt: "Magali Clouzet, consultante marketing stratégique — portrait professionnel",
    badgeLabel: "Basée sur la Côte d'Azur",
    badgeCities: "Nice · Sophia Antipolis · Cannes · Antibes · Monaco",
    parcours: {
      tag: "Mon parcours",
      h2: "12 ans à bâtir et déployer des marques fortes, en France et à l'international",
      paragraphs: [
        "Avant de devenir consultante indépendante sur la Côte d'Azur, j'ai évolué pendant 12 ans au sein de groupes internationaux, notamment comme Responsable Marketing.",
        "J'y ai piloté le lancement de plus de 120 produits sur des marchés aussi exigeants que variés, de la santé/pharmaceutique au jouet, en France comme à l'international.",
        "Cette expérience m'a appris une chose essentielle : les fondamentaux du marketing sont universels, mais leur mise en œuvre doit toujours s'adapter à la réalité de l'entreprise, de son marché et de ses ressources.",
        "Après ces années en entreprise, j'ai choisi de mettre cette expérience au service des dirigeants qui ont besoin d'un regard marketing senior, de méthode et de recul, sans nécessairement recruter une direction marketing à temps plein.",
      ],
      cards: [
        { title: "12 ans d'expertise", text: "En stratégie marketing, stratégie de marque et lancement de produits." },
        { title: "120+ produits lancés", text: "Sur des marchés compétitifs et variés, du pharmaceutique au jouet." },
        { title: "Expérience internationale", text: "Pilotage de lancements en France et en Angleterre, coordination de déploiements européens et gestion de projets internationaux (USA, Japon)." },
        { title: "Bilingue français–anglais", text: "Pour piloter vos projets en France comme à l'international." },
      ],
    },
    approach: {
      tag: "Mon approche",
      h2: "Une consultante, trois convictions.",
      values: [
        { title: "Créativité", text: "Sortir des chemins battus pour dénicher l'angle stratégique qui vous démarque, sans jamais perdre de vue vos objectifs business et votre rentabilité." },
        { title: "Pédagogie", text: "Chaque choix stratégique est expliqué, pas simplement livré. Mon rôle est aussi de transmettre, pour que vous puissiez décider et arbitrer en toute autonomie." },
        { title: "Proximité", text: "Une relation de confiance, transparente et durable. Je vous accompagne à chaque étape de la mission et reste un partenaire disponible sur le long terme pour vos arbitrages." },
      ],
    },
    who: {
      tag: "Pour qui ?",
      h2: "Trois profils, une même exigence de résultats.",
      profiles: [
        { title: "Fondateurs de Start-ups", text: "Valider votre positionnement et réussir votre lancement. Je vous aide à structurer une stratégie Go-To-Market claire et déployer une visibilité forte dès le premier jour." },
        { title: "Dirigeants de PME", text: "Votre activité grandit, mais votre marketing manque d'alignement ou de temps de pilotage ? Comme directeur marketing externalisé, je remets de la méthode et priorise les actions à plus fort impact." },
        { title: "TPE & Indépendants", text: "Sortir du marketing « au coup par coup » sans embaucher à temps plein. J'apporte un regard extérieur, des outils adaptés et une coordination efficace de vos prestataires." },
      ],
      cta: "Découvrir mes services",
    },
    ctaBlock: {
      title: "Un projet marketing sur la Côte d'Azur ou à distance ? Faisons connaissance.",
      textA: "Un premier échange de 30 minutes, sans engagement, pour analyser votre situation et clarifier vos priorités. Écrivez-moi à",
      textB: "ou réservez directement un créneau qui vous convient.",
      ctaLabel: "Réserver un échange (30 min)",
    },
  },
  servicesPage: {
    seo: {
      title: "Services Marketing : Audit, Lancement & CMO | Magali Clouzet",
      description:
        "Diagnostic stratégique, plan de lancement Go-To-Market ou direction marketing à temps partagé. Des prestations sur-mesure pour PME et start-ups.",
    },
    breadcrumb: "Mes services",
    tag: "Mes services",
    h1: "Accompagnement et Conseil Marketing Stratégique sur la Côte d'Azur",
    accent: "Des accompagnements structurés pour des résultats concrets.",
    introA: "Trois formats d'accompagnement sur-mesure pour les PME, start-ups et TPE à Nice, Sophia Antipolis, Cannes, Antibes, Monaco ou à distance. Chaque mission débouche sur des",
    introStrong: "priorités claires et un plan d'action directement opérationnel",
    introB: "— jamais sur un rapport théorique.",
    customStrong: "Besoin d'un accompagnement spécifique ?",
    customText: "Toutes mes prestations sont adaptables. J'interviens également sur des missions ponctuelles sur mesure — un atelier stratégique, une prise de parole, un audit ciblé.",
    customCta: "Échangeons sur votre projet",
    customSubject: "Mission sur mesure",
  },
  offerPage: {
    summaryTitle: "En résumé",
    audienceTitle: "Pour qui ?",
    includedTag: "Ce qui est inclus",
    includedH2: "Un périmètre clair, sans surprise.",
    processTag: "Le déroulement",
    processH2: "Comment se passe la mission ?",
    deliverablesTag: "Les livrables",
    deliverablesH2: "Vos livrables concrets à la fin de la mission.",
    othersTitle: "Découvrir aussi",
    ctaDefaultText: "Un premier échange gratuit et sans engagement pour vérifier que ce format répond à votre situation — et repartir avec une proposition claire.",
    servicesBreadcrumb: "Mes services",
  },
  blogPage: {
    seo: {
      title: "Blog marketing stratégique : PME, start-up, Go-To-Market, IA",
      description:
        "Articles et conseils en marketing stratégique : positionnement, stratégie de marque, Go-To-Market, direction marketing externalisée et IA marketing pour PME et start-ups.",
    },
    breadcrumb: "Blog",
    tag: "Le blog",
    h1: "Marketing stratégique, sans bullshit.",
    subtitle: "Méthodes, analyses et conseils concrets pour les dirigeants de PME, fondateurs de start-ups et responsables marketing.",
    searchPlaceholder: "Rechercher un article…",
    searchAria: "Rechercher un article",
    filterAria: "Filtrer par catégorie",
    all: "Tous",
    noResult: "Aucun article ne correspond à votre recherche.",
  },
  articlePage: {
    by: "Par",
    summaryTitle: "En résumé",
    authorRole: "Consultante marketing stratégique",
    authorBio: "Consultante marketing stratégique. J'aide PME, start-ups et TPE à transformer leur marketing en levier de croissance.",
    authorLink: "En savoir plus",
    authorAlt: "Magali Clouzet, consultante marketing stratégique",
    relatedTitle: "À lire ensuite",
    readArticle: "Lire l'article",
    backToBlog: "Retour au blog",
    breadcrumbBlog: "Blog",
  },
  contactPage: {
    seo: {
      title: "Contact & Échange Stratégique Offert | Magali Clouzet",
      description:
        "Prêt à structurer votre marketing ? Réservez un premier échange gratuit de 30 min. Accompagnement sur la Côte d'Azur (Antibes, Nice, Cannes) ou à distance.",
    },
    breadcrumb: "Contact",
    tag: "Contact",
    h1: "Échangeons sur votre projet.",
    intro:
      "Parlez-moi de votre situation, vos enjeux, vos objectifs. Je vous réponds personnellement sous 48 h ouvrées — et si je ne suis pas la bonne personne, je vous le dis et vous oriente au mieux.",
    calendlyTitle: "Prendre rendez-vous",
    calendlySub: "30 minutes, gratuit et sans engagement",
    emailTitle: "Par email",
    linkedinTitle: "Sur LinkedIn",
    linkedinSub: "Suivre mes publications et échanger",
    zoneTitle: "Zone d'intervention",
    formTitle: "Demander un devis",
    formSubtitle: "Complétez ces quelques champs : votre message m'arrive directement par email.",
    labelName: "Votre nom",
    labelCompany: "Votre entreprise",
    labelEmail: "Votre email",
    labelMessage: "Votre projet en quelques mots",
    placeholderName: "Prénom Nom",
    placeholderCompany: "Nom de votre entreprise",
    placeholderEmail: "vous@entreprise.com",
    placeholderMessage: "Contexte, enjeux, objectifs, échéances…",
    submit: "Envoyer ma demande",
    sending: "Envoi en cours…",
    successTitle: "Message envoyé !",
    successTextA: "Merci",
    successTextB: ", votre demande est bien arrivée. Je vous réponds personnellement sous 48 h ouvrées.",
    errorA: "L'envoi a échoué. Réessayez ou écrivez-moi à",
    privacyNote: "Vos données servent uniquement à répondre à votre demande.",
    subjectPrefix: "Nouvelle demande de devis",
    fromName: "Site Magali Clouzet",
  },
  faqPage: {
    seo: {
      title: "FAQ Conseil & Direction Marketing Côte d'Azur | Magali Clouzet",
      description:
        "Toutes vos questions sur la direction marketing externalisée, le diagnostic et mes méthodes à Antibes, Sophia Antipolis, Nice et à distance.",
    },
    breadcrumb: "FAQ",
    tag: "FAQ",
    h1: "Vos questions, mes réponses.",
    intro:
      "Tout ce que vous devez savoir avant de me confier votre marketing. Une question n'apparaît pas ici ? N'hésitez pas à m'écrire, je m'efforce de vous répondre dans les meilleurs délais.",
    ctaTitle: "Une question spécifique ?",
    ctaText: "Le premier échange est fait pour ça : 30 à 45 minutes pour parler de votre situation, gratuitement et sans engagement.",
  },
  legalPage: {
    seo: {
      title: "Mentions légales",
      description: "Mentions légales du site de Magali Clouzet, consultante marketing stratégique.",
    },
    breadcrumb: "Mentions légales",
    h1: "Mentions légales",
    sections: [
      {
        title: "Éditeur du site",
        paragraphs: [
          "Magali Clouzet — Entrepreneur individuel\nConsultante en stratégie marketing\nSIRET : 108 359 597 00011\nBasée à Antibes (06600), Alpes-Maritimes, France — adresse complète disponible sur demande\nEmail : contact@magaliclouzet.com",
        ],
      },
      { title: "Directrice de la publication", paragraphs: ["Magali Clouzet"] },
      {
        title: "Hébergement",
        paragraphs: [
          "Ce site est hébergé par Hostinger International Ltd., 61 Lordou Vironos Street, 6023 Larnaca, Chypre — www.hostinger.com",
        ],
      },
      {
        title: "Propriété intellectuelle",
        paragraphs: [
          "L'ensemble des contenus du site (textes, visuels, identité graphique) est la propriété exclusive de Magali Clouzet, sauf mention contraire. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.",
        ],
      },
      {
        title: "Responsabilité",
        paragraphs: [
          "Les informations publiées sur ce site le sont à titre indicatif. Magali Clouzet ne saurait être tenue responsable des omissions, inexactitudes ou carences de mise à jour. Les liens externes proposés n'engagent pas sa responsabilité.",
        ],
      },
      { title: "Contact", paragraphs: ["Pour toute question relative au site : contact@magaliclouzet.com"] },
    ],
  },
  privacyPage: {
    seo: {
      title: "Politique de confidentialité",
      description:
        "Politique de confidentialité et protection des données personnelles (RGPD) du site de Magali Clouzet, consultante marketing stratégique.",
    },
    breadcrumb: "Politique de confidentialité",
    h1: "Politique de confidentialité",
    updated: "Dernière mise à jour : juillet 2026",
    sections: [
      {
        title: "Responsable de traitement",
        paragraphs: [
          "Magali Clouzet, consultante marketing stratégique — contact@magaliclouzet.com. Le présent site respecte le Règlement Général sur la Protection des Données (RGPD) et la loi Informatique et Libertés.",
        ],
      },
      {
        title: "Données collectées",
        paragraphs: [
          "Le formulaire de contact transmet les informations que vous saisissez (nom, entreprise, email, message) via le service sécurisé Web3Forms, qui me les fait parvenir par email. Elles servent uniquement à répondre à votre demande et ne sont ni vendues, ni utilisées à d'autres fins.",
          "Lorsque vous m'écrivez par email, je collecte uniquement les données nécessaires au traitement de votre demande : nom, coordonnées et contenu de votre message.",
        ],
      },
      {
        title: "Finalités et durée de conservation",
        paragraphs: [
          "Vos données servent exclusivement à répondre à votre demande et, le cas échéant, à établir une proposition commerciale. Elles ne sont ni vendues, ni cédées à des tiers. Elles sont conservées au maximum 3 ans après notre dernier échange.",
        ],
      },
      {
        title: "Cookies",
        paragraphs: [
          "Ce site n'utilise pas de cookies de suivi ou publicitaires. Seuls des cookies strictement nécessaires au fonctionnement technique peuvent être déposés.",
        ],
      },
      {
        title: "Vos droits",
        paragraphs: [
          "Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition concernant vos données personnelles. Pour les exercer, écrivez à contact@magaliclouzet.com. Vous pouvez également saisir la CNIL (www.cnil.fr) en cas de litige.",
        ],
      },
    ],
  },
};
